// Les URLs d'API ne vivent plus ici : elles sont chargees au demarrage par
// ConfigService depuis `configFile`, servi sans cache par nginx et substitue
// a chaque deploiement. Ce fichier ne porte donc que ce que le code lit
// reellement : production, version et configFile.
export const environment = {
    'env': 'pp',
    'production': false,
    'lastPubli':'05/04/2024 à 12h00',
    'version': '0.0.34',
    'configFile': 'assets/config.json'

};
